import isEmpty from 'lodash/isEmpty';

import { Decline } from '../../../slices/decline';
import type { AnalyticsEvent } from '../types-only';

const getDeclines = (
  state: Decline,
  eventPayload?: AnalyticsEvent & { eventCategory?: string }
) => {
  if (!state) return {};

  // Check Payload whether error existed, then check redux store, because of the race condition of the redux dispatch.
  const isDeclined =
    !isEmpty(eventPayload) &&
    /^(?:business.|technical.)?error$/.test(eventPayload.eventCategory ?? '');
  return {
    genericDimensionThree: `is declined|${isDeclined}`,
  };
};

export default getDeclines;
